export default __webpack_public_path__ + "static/media/kanosface.5337f1ef.jpg";